import { ENV_CONSTS } from './env-consts.ts';
import { TranslationKey } from './i18n.ts';

export const devMode = import.meta.env.DEV;
export const b2cVersion = ENV_CONSTS.SITE_TYPE === 'b2c';
export const b2bVersion = !b2cVersion;

export const appConfig = b2cVersion
  ? {
      restAPI: ENV_CONSTS.B2C_REST_API,
      wsAPI: ENV_CONSTS.B2C_WS_API,
    }
  : {
      restAPI: ENV_CONSTS.B2B_REST_API,
      wsAPI: ENV_CONSTS.B2B_WS_API,
    };

export const links = {
  exclusiveTournament:
    'https://coinraces.medium.com/coinraces-crdao-genesis-launch-exclusive-tournament-1-000-virtual-prize-ffae52248c60',
  howToPlay: 'https://coinraces.gitbook.io/coinraces/game/how-does-it-work',
  about: 'https://coinraces.io/about',
  refer: 'https://coinraces.io/refer',
  discord: 'https://discord.com/invite/ApPmbDCj3m',
} as const;

export const socialLinks = {
  twitter: 'https://x.com/CoinRacesGame',
  telegram: 'https://t.me/coinraces',
} as const;

export type SocialLinkName = keyof typeof socialLinks;

export const referralUrlParam = 'refcode';

export const menuLinks: Array<{
  label: TranslationKey;
  href: (typeof links)[keyof typeof links];
}> = [
  {
    label: 'HEADER_MENU__howToPlayLink',
    href: links.howToPlay,
  },
  {
    label: 'HEADER_MENU__aboutLink',
    href: links.about,
  },
];
